import React, { useState } from 'react';
import 'Assets/styles/default/pages/focalPoint/FocalPointManagePointsStyles.less';
import {
    VertModal,
    VertButton,
    Typography,
    VertIcon
} from '@vertem-core/vertice-ds';
import { Col, Row } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';
import UploadSummary from '../Modals/UploadSummary';

const UploadSuccess = ({ isOpen, onClose, finishUpload, decimalPlaces, pointsName, balance, totalSum }) => {

    const [showModalSummary, setShowModalSummary] = useState(false);

    return (
        <VertModal
            destroyOnClose={true}
            open={isOpen}
            onCancel={() => {
                onClose();
            }}
            className="container-modal-focal-point-manage modal-terms-aprovation"
        >
            <Row justify={'center'} gutter={[8, 8]}
            >
                <Col span={24} className='mt-16'>
                    <Row justify={'center'}>
                        <VertIcon
                            size="large"
                            className='icon-summary-upload-distribution'
                            component={CheckCircleFilled}
                        />
                    </Row>
                </Col>

                <Col span={24} className='mt-16'>
                    <Row justify={'center'}>
                        <Typography.Text strong className="manage-points-details-main">
                            Planilha enviada com sucesso!
                        </Typography.Text>
                    </Row>
                </Col>

                <Col span={24} className='mt-16'>
                    <div className='modal-upload-divider' />
                </Col>

                <Col span={24} className='mt-16'>
                    <Row justify={'center'} gutter={[16, 16]}>
                        <Col span={10}>
                            <VertButton
                                type="highlight"
                                size="default"
                                className='button-historic-redirect button-focal-point width-100'
                                onClick={() => { setShowModalSummary(true) }}
                            >
                                Continuar...
                            </VertButton>
                        </Col>
                    </Row>
                </Col>

            </Row>

            <UploadSummary
                isOpen={showModalSummary}
                onClose={() => {
                    setShowModalSummary(false);
                    onClose();
                }}
                finishUpload={res => {
                    finishUpload(res);
                    onClose();
                }}
                decimalPlaces={decimalPlaces}
                pointsName={pointsName}
                balance={balance}
                totalSum={totalSum}
            />

        </VertModal >
    );
};

export default UploadSuccess;
